import { useQuery } from '@tanstack/react-query';
import { getIpInfo } from 'src/utils/getIPInfo';

export type IpInfo = {
  country: string;
  countryCode: string;
  city: string;
};

export const useGetIpInfo = (options?: { enabled?: boolean }) => {
  const { enabled = true } = options ?? {};

  return useQuery<IpInfo>({
    queryKey: ['ipInfo'],
    queryFn: getIpInfo,
    enabled,
    gcTime: 60 * 60 * 1000,
    staleTime: 60 * 60 * 1000,
    retry: 0,
    placeholderData: {
      country: 'United States',
      countryCode: 'US',
      city: 'New York',
    },
  });
};
